import ClickAwayListener from "react-click-away-listener";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/reduxHooks";
import { goToSidebarTab } from "../../../../../store/slices/sidebarSlice";
import { getDesignPDF } from "../../../../../api/editor.api";
import { useParams, useSearchParams } from "react-router-dom";

const Dropdown = ({
  hideDropdown,
  showDuplicate,
  showRename,
  showPDF,
}: any) => {
  const dispatch = useAppDispatch();
  const designName = useAppSelector((state: any) => state.canvases.designName);

  const [searchParams] = useSearchParams();
  const handle = searchParams.get("handle");
  const userId = searchParams.get("userId");
  const email = searchParams.get("email");

  const handleProjects = () => {
    dispatch(goToSidebarTab({ tab: "Account" }));
    hideDropdown();
  };

  return (
    <ClickAwayListener onClickAway={hideDropdown}>
      <div className="absolute bg-white rounded-lg flex flex-col items-start gap-4 p-5 shadow-header text-[14px] min-w-[200px] z-10">
        {userId ? (
          <button onClick={handleProjects}>
            <svg
              className="inline mr-2 -mt-1"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.25 5.3559H13.543C13.7055 5.35566 13.8656 5.41299 14.0094 5.52296C14.1532 5.63292 14.2764 5.7922 14.3684 5.987C14.4604 6.18181 14.5183 6.40629 14.5373 6.641C14.5562 6.87572 14.5355 7.1136 14.477 7.33408L12.622 14.3406C12.5494 14.6152 12.4213 14.8513 12.2545 15.0177C12.0878 15.1842 11.8903 15.2732 11.688 15.273H2.45701C2.29454 15.2732 2.13447 15.2159 1.99066 15.1059C1.84684 14.996 1.72362 14.8367 1.63164 14.6419C1.53966 14.4471 1.4817 14.2226 1.46277 13.9879C1.44385 13.7532 1.46452 13.5153 1.52301 13.2948L3.37801 6.28827C3.45062 6.01371 3.57875 5.77762 3.7455 5.61117C3.91224 5.44471 4.10977 5.35571 4.31201 5.3559H13.25ZM13.25 5.3559V3.50427C13.25 3.1185 13.1447 2.74853 12.9571 2.47575C12.7696 2.20297 12.5152 2.04972 12.25 2.04972H5.80001C5.66559 2.04973 5.53256 2.01031 5.40885 1.93384C5.28514 1.85736 5.1733 1.7454 5.08001 1.60463L4.79501 1.17408C4.70181 1.03305 4.59001 0.920818 4.4663 0.844091C4.34258 0.767364 4.2095 0.727723 4.07501 0.727539H2.43701C2.1718 0.727539 1.91744 0.880785 1.7299 1.15357C1.54237 1.42635 1.43701 1.79632 1.43701 2.18208V13.9494"
                stroke="black"
              />
            </svg>
            My Projects
          </button>
        ) : (
          ""
        )}{" "}
        {designName ? (
          <button onClick={showRename}>
            <svg
              className="inline mr-2 -mt-1"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_43891_36897"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
              >
                <path d="M16 0.772461H0V15.8313H16V0.772461Z" fill="white" />
              </mask>
              <g mask="url(#mask0_43891_36897)">
                <path
                  d="M4.06707 11.7632L3.90332 9.32912L12.4138 1.31934L14.9999 3.75334L6.48945 11.7632H4.06707Z"
                  stroke="black"
                />
                <path d="M9.75342 3.62109L12.4809 6.18814" stroke="black" />
                <path
                  d="M1.5 15.3604H14.5"
                  stroke="black"
                  strokeLinecap="round"
                />
              </g>
            </svg>
            Rename
          </button>
        ) : (
          ""
        )}
        {/* <button onClick={showDuplicate}>
          <svg
            className="inline mr-2 -mt-1"
            width="16"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.375 3.125H3.75C3.49112 3.125 3.28125 3.33569 3.28125 3.59559V11.125C3.28125 11.3849 3.49112 11.5956 3.75 11.5956H9.375C9.63388 11.5956 9.84375 11.3849 9.84375 11.125V3.59559C9.84375 3.33569 9.63388 3.125 9.375 3.125Z"
              fill="white"
              stroke="black"
            />
            <path
              d="M11.25 5.00781H5.625C5.36612 5.00781 5.15625 5.2185 5.15625 5.4784V13.0078C5.15625 13.2677 5.36612 13.4784 5.625 13.4784H11.25C11.5089 13.4784 11.7188 13.2677 11.7188 13.0078V5.4784C11.7188 5.2185 11.5089 5.00781 11.25 5.00781Z"
              fill="white"
              stroke="black"
            />
          </svg>
          Duplicate Design
        </button> */}
        {designName ? (
          <button onClick={showPDF}>
            <svg
              className="inline mr-2 -mt-1"
              width="16"
              height="16"
              viewBox="0 0 15 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.10681 13.9482H13.3568"
                stroke="black"
                strokeLinecap="round"
              />
              <path
                d="M7.78772 9.91608L7.78895 2.57031"
                stroke="black"
                strokeLinecap="round"
              />
              <path
                d="M5.23181 8.00586L7.78796 10.8128L10.3441 8.00586"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Download The PDF
          </button>
        ) : (
          ""
        )}
      </div>
    </ClickAwayListener>
  );
};
export default Dropdown;
